export const BasicEmotions = [
    { id: "happy", korean: "행복하다", english: "to be happy", romanization: "haeng-bok-ha-da" },
    { id: "sad", korean: "슬프다", english: "to be sad", romanization: "seul-peu-da" },
    { id: "angry", korean: "화나다", english: "to be angry", romanization: "hwa-na-da" },
    { id: "scared", korean: "무섭다", english: "to be scared", romanization: "mu-seop-da" },
    { id: "tired", korean: "피곤하다", english: "to be tired", romanization: "pi-gon-ha-da" },
    { id: "bored", korean: "심심하다", english: "to be bored", romanization: "sim-sim-ha-da" },
    { id: "surprised", korean: "놀라다", english: "to be surprised", romanization: "nol-la-da" },
    { id: "calm", korean: "차분하다", english: "to be calm", romanization: "cha-bun-ha-da" },
    { id: "excited", korean: "신나다", english: "to be excited", romanization: "sin-na-da" },
    { id: "confused", korean: "헷갈리다", english: "to be confused", romanization: "het-gal-li-da" },
    { id: "worried", korean: "걱정하다", english: "to worry", romanization: "geok-jeong-ha-da" },
];

export const ComplexEmotions = [
    { id: "embarrassed", korean: "창피하다", english: "to be embarrassed", romanization: "chang-pi-ha-da" },
    { id: "nervous", korean: "긴장하다", english: "to be nervous", romanization: "gin-jang-ha-da" },
    { id: "lonely", korean: "외롭다", english: "to be lonely", romanization: "oe-rop-da" },
    { id: "jealous", korean: "질투하다", english: "to be jealous", romanization: "jil-tu-ha-da" },
    { id: "disappointed", korean: "실망하다", english: "to be disappointed", romanization: "sil-mang-ha-da" },
    { id: "relieved", korean: "안도하다", english: "to be relieved", romanization: "an-do-ha-da" },
    { id: "grateful", korean: "감사하다", english: "to be grateful", romanization: "gam-sa-ha-da" },
    { id: "confident", korean: "자신 있다", english: "to be confident", romanization: "ja-sin it-da" },
    { id: "curious", korean: "궁금하다", english: "to be curious", romanization: "gung-geum-ha-da" },
    { id: "embarrassed-shy", korean: "부끄럽다", english: "to be shy / embarrassed", romanization: "bu-kkeu-reop-da" },
];

export const NegativeEmotions = [
    { id: "frustrated", korean: "좌절하다", english: "to be frustrated", romanization: "jwa-jeol-ha-da" },
    { id: "depressed", korean: "우울하다", english: "to be depressed", romanization: "u-ul-ha-da" },
    { id: "guilty", korean: "죄책감을 느끼다", english: "to feel guilty", romanization: "joe-chaek-gam-eul neu-kki-da" },
    { id: "hurt", korean: "상처받다", english: "to be hurt (emotionally)", romanization: "sang-cheo-bat-da" },
    { id: "annoyed", korean: "짜증나다", english: "to be annoyed", romanization: "jja-jeung-na-da" },
    { id: "ashamed", korean: "수치스럽다", english: "to be ashamed", romanization: "su-chi-seu-reop-da" },
    { id: "anxious", korean: "불안하다", english: "to be anxious", romanization: "bul-an-ha-da" },
    { id: "regretful", korean: "후회하다", english: "to regret", romanization: "hu-hoe-ha-da" },
    { id: "upset", korean: "속상하다", english: "to be upset", romanization: "sok-sang-ha-da" },
    { id: "embittered", korean: "억울하다", english: "to feel wronged / resentful", romanization: "eog-ul-ha-da" },
];

export const PositiveEmotions = [
    { id: "proud", korean: "자랑스럽다", english: "to be proud", romanization: "ja-rang-seu-reop-da" },
    { id: "satisfied", korean: "만족하다", english: "to be satisfied", romanization: "man-jok-ha-da" },
    { id: "hopeful", korean: "희망하다", english: "to be hopeful", romanization: "hui-mang-ha-da" },
    { id: "cheerful", korean: "명랑하다", english: "to be cheerful", romanization: "myeong-nang-ha-da" },
    { id: "peaceful", korean: "평화롭다", english: "to be peaceful", romanization: "pyeong-hwa-rop-da" },
    { id: "in-love", korean: "사랑하다", english: "to love", romanization: "sa-rang-ha-da" },
    { id: "inspired", korean: "영감을 받다", english: "to be inspired", romanization: "yeong-gam-eul bat-da" },
    { id: "relaxed", korean: "편안하다", english: "to be relaxed", romanization: "pyeon-an-ha-da" },
    { id: "grateful", korean: "감동하다", english: "to be touched / moved", romanization: "gam-dong-ha-da" },
    { id: "motivated", korean: "의욕적이다", english: "to be motivated", romanization: "ui-yok-jeog-i-da" },
];

export const SpecialStates = [
    { id: "focused", korean: "집중하다", english: "to be focused", romanization: "jip-jung-ha-da" },
    { id: "sleepy", korean: "졸리다", english: "to be sleepy", romanization: "jol-li-da" },
    { id: "surprised", korean: "놀라다", english: "to be surprised", romanization: "nol-la-da" },
    { id: "confused", korean: "헷갈리다", english: "to be confused", romanization: "het-gal-li-da" },
    { id: "shocked", korean: "충격받다", english: "to be shocked", romanization: "chung-gyeok-bat-da" },
    { id: "relieved", korean: "안도하다", english: "to be relieved", romanization: "an-do-ha-da" },
    { id: "dizzy", korean: "어지럽다", english: "to be dizzy", romanization: "eo-ji-reop-da" },
    { id: "tired", korean: "피곤하다", english: "to be tired", romanization: "pi-gon-ha-da" },
    { id: "curious", korean: "궁금하다", english: "to be curious", romanization: "gung-geum-ha-da" },
    { id: "embarrassed", korean: "부끄럽다", english: "to be embarrassed / shy", romanization: "bu-kkeu-reop-da" },
];
